export const getCountry = () => window.Shopify.country;

export const isDomestic = () => getCountry() === "US";
